<template>
    <div class="row panel-body">
        <form method="post" ref="form" :action="postRoute">
            <input type="hidden" name="_token" :value="csrfToken"/>

            <quiz-translated-localization-question
                    v-for="(question, idx) in questions"
                    v-on:forceUpdate="forceUpdate()"
                    ref="questions"
                    :idx="idx"
                    :key="question.qid"
                    :qid="question.qid"
                    :type="question.type"
                    :level="question.level"
                    :XX_en="question.text.XX_en"
                    :suggestedAnswerOid="question.suggestedAnswerOid"
                    :itransLocalization="question.text[locale]"
                    :localization="question.text[localizationLocale]"
                    :ioptions="question.options"
                    :locale="locale"
                    :localizationLocale="localizationLocale"
                    :country-name="countryName"
                    :pictureUrl="question.pictureUrl"
            ></quiz-translated-localization-question>

            <div class="row">
                <div class="col-xs-12 text-right">
                    <submit-button :disabled="!allDataIsValid" title="Submit"></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: {
            questionsJson: String,
            locale: String,
            localizationLocale: String,
            countryName: String,
            postRoute: String,
        },

        data: function() {
            return {
                questions: [],
                csrfToken: window.csrfToken,
                updateTrigger: false,
            };
        },

        computed: {
            allDataIsValid: function() {
                if (this.updateTrigger) {
                    for (let index in this.$refs.questions) {
                        if (!this.$refs.questions[index].validate()) {
                            return false;
                        }
                    }
                    return true;
                }
            },
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            let tmpQuestionsArray = [];
            for (let idx in questions) {
                if (!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                tmpQuestionsArray.push(questions[idx]);
            }
            // don't push to this.questions inside of the loop, because it triggers re-rendering in every iteration.
            this.questions = tmpQuestionsArray;

            this.updateTrigger = true;
            this.forceUpdate();
        },

        methods: {
            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
            },

            // don't auto-save here, because we cannot restore WiP that only contains part of the quiz
        },
    };
</script>
